import React from 'react';

import styled, { css } from 'styled-components';

import { breakpoints, Row } from '@notino/react-styleguide-v20';

import { DEFAULT_CART_FONT_SIZE_TEXT_IN_REM, PAGE_MAX_WIDTH } from '../constants';
import { IActive, IBasicTestProps } from '../model';

export const b = (chunks: React.ReactNode[]) => <Bold key={chunks?.toString()}>{chunks}</Bold>;

export const Bold = styled.span`
  font-weight: bold;
`;

export const defaultFontSizeCSS = css`
  font-size: ${DEFAULT_CART_FONT_SIZE_TEXT_IN_REM};
`;

export const centeredContentCSS = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledBasicRowWrapper = styled(Row).attrs(({ dataTestId }: IBasicTestProps) => ({
  className: dataTestId,
}))<IBasicTestProps>``;

export const StyledBasicWrapper = styled.div.attrs(() => ({}))<IBasicTestProps>``;

export const StyledCartWrapper = styled(StyledBasicWrapper)`
  ${defaultFontSizeCSS};
`;

export const StyledPointerEventsWrapper = styled(StyledCartWrapper)<IActive>`
  cursor: pointer !important;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')} !important;
`;

export const StyledCenteredDiv = styled.div`
  ${centeredContentCSS}
`;

export const StyledCheckoutWrapper = styled.div`
  max-width: ${PAGE_MAX_WIDTH}rem;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: ${breakpoints.md}) {
    padding-bottom: 3.125rem;
  }
`;

export const Normal = styled.span`
  ${defaultFontSizeCSS};
`;
